import { Step as StepProps } from '@service-victoria/component-library/components/Wizard/props';
import React from 'react';

import * as Interfaces from 'app/interfaces';
import { constants } from 'app/utils';

const Component = React.lazy(() => import('./Done'));

const Step: StepProps<Interfaces.Common.ProviderFormValues> = {
  id: 'done',
  title: constants.ProviderDetailsPage.title,
  stepName: 'Done',
  Component,
  navigation: {
    normal: [
      {
        content: 'Done',
        shouldValidate: false,
        type: 'primary',
        onClick: async (_, formProps): Promise<void> => {
          formProps.setValues({} as never, false);

          setTimeout(() => {
            // Navigate back to Dashboard page
            window.location.href = `${import.meta.env.BASE_URL || ''}${constants.Routes.Dashboard}`;
          }, 0);
        }
      }
    ]
  }
};

export { Step };
